import { render, staticRenderFns } from "./CustomGridItem.vue?vue&type=template&id=295d4a9c&"
import script from "./CustomGridItem.vue?vue&type=script&lang=js&"
export * from "./CustomGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports